import './_cart-footer-product.scss';
import component from './cart-footer-product';

export default component;
